"use client";

import { createContext, useContext, type ReactNode } from "react";

const PublicSignupContext = createContext(false);

export function PublicSignupProvider({
  enabled,
  children,
}: {
  enabled: boolean;
  children: ReactNode;
}) {
  return (
    <PublicSignupContext.Provider value={enabled}>
      {children}
    </PublicSignupContext.Provider>
  );
}

export function usePublicSignupEnabled() {
  return useContext(PublicSignupContext);
}
